import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        background: '#FFFFFF',
        padding: '40px',
        border: '4px solid #333333',
        boxShadow: '8px 8px 0px rgba(0, 0, 0, 0.3)'
      }}>
        <h1 style={{
          margin: '0 0 12px 0',
          fontSize: '2.5rem',
          fontWeight: '900',
          color: '#333333',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          Privacy Policy
        </h1>

        <p style={{
          margin: '0 0 32px 0',
          fontSize: '0.95rem',
          color: '#666666',
          fontStyle: 'italic'
        }}>
          Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div style={{
          padding: '20px',
          background: '#e3f2fd',
          border: '2px solid #1976d2',
          borderRadius: '4px',
          marginBottom: '32px'
        }}>
          <p style={{
            margin: '0',
            fontSize: '1rem',
            color: '#0d47a1',
            fontWeight: '600',
            lineHeight: '1.6'
          }}>
            <strong>Your Privacy Matters:</strong> We are committed to protecting your personal information
            and being transparent about how we collect and use your data.
          </p>
        </div>

        {/* Section 1 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            1. Information We Collect
          </h2>

          <h3 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#444444', marginTop: '16px', marginBottom: '8px' }}>
            Account Information
          </h3>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Email address</li>
            <li>Name (first and last)</li>
            <li>Date of birth (for age verification)</li>
            <li>Username and password (encrypted)</li>
          </ul>

          <h3 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#444444', marginTop: '16px', marginBottom: '8px' }}>
            Educational Activity Data
          </h3>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Simulated portfolio choices and trades</li>
            <li>Investment simulation performance</li>
            <li>Questions asked to the AI guide</li>
            <li>Platform usage patterns and interactions</li>
            <li>Learning progress and achievements</li>
          </ul>

          <h3 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#444444', marginTop: '16px', marginBottom: '8px' }}>
            Technical Data
          </h3>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>Login timestamps</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>
        </section>

        {/* Section 2 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            2. How We Use Your Information
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            We use your information to:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li><strong>Provide the Service:</strong> Create and manage your account, track your simulated portfolio</li>
            <li><strong>Improve Education:</strong> Analyze usage patterns to enhance learning features</li>
            <li><strong>Personalize Experience:</strong> Tailor AI guidance to your learning level</li>
            <li><strong>Verify Age:</strong> Ensure compliance with our 16+ age requirement</li>
            <li><strong>Communicate:</strong> Send important updates, security alerts, or educational content</li>
            <li><strong>Security:</strong> Detect and prevent fraud, abuse, or security issues</li>
            <li><strong>Analytics:</strong> Understand how users interact with the platform</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            3. Data Sharing and Disclosure
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            <strong>We do NOT sell your personal information.</strong>
          </p>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            We may share data only in these limited circumstances:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li><strong>Service Providers:</strong> Third-party services that help us operate the platform (e.g., hosting, analytics, AI services)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect rights and safety</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets</li>
            <li><strong>With Your Consent:</strong> When you explicitly authorize sharing</li>
          </ul>
        </section>

        {/* Section 4 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            4. Cookies and Tracking
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            We use cookies and similar technologies to:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Keep you logged in</li>
            <li>Remember your preferences</li>
            <li>Analyze platform performance</li>
            <li>Understand user behavior</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            You can control cookies through your browser settings, but some features may not work properly if cookies are disabled.
          </p>
        </section>

        {/* Section 5 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            5. Data Security
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            We implement industry-standard security measures to protect your data:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Encrypted password storage</li>
            <li>Secure HTTPS connections</li>
            <li>Regular security audits</li>
            <li>Access controls and authentication</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            However, no system is 100% secure. You are responsible for keeping your account credentials confidential.
          </p>
        </section>

        {/* Section 6 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            6. Data Retention
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            We retain your personal information for as long as your account is active or as needed to provide the Service.
            You may request account deletion at any time. After deletion, some data may be retained for legal compliance or security purposes.
          </p>
        </section>

        {/* Section 7 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            7. Your Rights
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            You have the right to:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li><strong>Access:</strong> Request a copy of your personal data</li>
            <li><strong>Correction:</strong> Update or correct inaccurate information</li>
            <li><strong>Deletion:</strong> Request deletion of your account and data</li>
            <li><strong>Export:</strong> Download your data in a portable format</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            To exercise these rights, contact us at:{' '}
            <a href="mailto:privacy@example.com" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: '600' }}>
              privacy@example.com
            </a>
          </p>
        </section>

        {/* Section 8 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            8. Children's Privacy
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            This Service is intended for users aged 16 and older.
            We do not knowingly collect data from children under 16.
            If we discover that a user under 16 has created an account, we will delete it promptly.
          </p>
        </section>

        {/* Section 9 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            9. Third-Party Services
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            The platform may use third-party services:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li><strong>Google Authentication:</strong> For OAuth login (governed by Google's Privacy Policy)</li>
            <li><strong>AI Services:</strong> For the investment guide feature</li>
            <li><strong>Analytics Tools:</strong> To understand platform usage</li>
            <li><strong>Market Data Providers:</strong> For real-time stock information</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            These services have their own privacy policies, which we encourage you to review.
          </p>
        </section>

        {/* Section 10 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            10. International Users
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            This Service is operated from Israel.
            If you access the Service from outside Israel, your data may be transferred to and processed in Israel.
            By using the Service, you consent to this transfer.
          </p>
        </section>

        {/* Section 11 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            11. Changes to This Policy
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            We may update this Privacy Policy from time to time.
            We will notify you of significant changes via email or platform notification.
            Continued use of the Service after changes constitutes acceptance of the updated policy.
          </p>
        </section>

        {/* Section 12 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            12. Contact Us
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            If you have questions about this Privacy Policy or how we handle your data, please contact us:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px', listStyle: 'none' }}>
            <li style={{ marginTop: '8px' }}>
              <strong>Email:</strong>{' '}
              <a href="mailto:privacy@example.com" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: '600' }}>
                privacy@example.com
              </a>
            </li>
            <li style={{ marginTop: '8px' }}>
              <strong>Support:</strong>{' '}
              <a href="mailto:support@example.com" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: '600' }}>
                support@example.com
              </a>
            </li>
          </ul>
        </section>

        {/* Back Button */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <Link
            to="/"
            style={{
              display: 'inline-block',
              padding: '14px 32px',
              fontSize: '1.1rem',
              fontWeight: '900',
              color: '#FFFFFF',
              background: '#667eea',
              border: '3px solid #333333',
              boxShadow: '4px 4px 0px #333333',
              textDecoration: 'none',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease'
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
